module.exports = __webpack_public_path__ + "img/ic_edit.a12e24e5.svg";